export const userStatuses = [
  { value: 'ACTIVE', label: 'Active' },
  { value: 'INACTIVE', label: 'Inactive' },
];

export const roles = [
  { value: 'OWNER', label: 'Owner' },
  { value: 'SUPERVISOR', label: 'Supervisor' },
  { value: 'MAINTAINER', label: 'Maintainer' },
];
